/*
 * Checks eventMarkers and sidePanelEventMarkers to find the first event that occurred.
 * It is used for displaying the "filter match" tooltip
 */
import type { EventMarker } from '../types';

export const findFirstFilterMatch = (
  eventMarkers: Array<EventMarker>,
  sidePanelEventMarkers: Array<EventMarker> | undefined,
): EventMarker | null => {
  const eventMarkerMatch = eventMarkers.filter((marker) => marker.is_highlighted)[0];
  const sidePanelEventMarkerMatch =
    sidePanelEventMarkers && sidePanelEventMarkers.filter((marker) => marker.is_highlighted)[0];

  if (!sidePanelEventMarkerMatch && eventMarkerMatch) return eventMarkerMatch;
  if (!eventMarkerMatch && sidePanelEventMarkerMatch) return sidePanelEventMarkerMatch;

  if (eventMarkerMatch && sidePanelEventMarkerMatch) {
    return eventMarkerMatch.time < sidePanelEventMarkerMatch.time
      ? eventMarkerMatch
      : sidePanelEventMarkerMatch;
  }
  return null;
};
